import { render, staticRenderFns } from "./Messages2.vue?vue&type=template&id=a782b75a"
import script from "./Messages2.vue?vue&type=script&lang=js"
export * from "./Messages2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports